import { TableName } from '../../config'

export const resolveBulkActionEndpoint = (name: string, portfolioModalOpen: boolean): string => {
    if (name === TableName.Portfolio || portfolioModalOpen) {
        return 'bulk-actions/update-portfolio'
    }

    switch (name) {
        case TableName.Recipes:
        case TableName.Segments:
            return 'recipes/bulk'
        case TableName.PublicRecipes:
            return 'admin/public-recipes/bulk'
        case TableName.Promotions:
            return 'promotions/bulk'
        default:
            return 'bulk-actions/update'
    }
}

const SYNCHRONOUS_BULK_ACTION_ENDPOINTS = new Set([
    'recipes/bulk',
    'promotions/bulk',
    'admin/public-recipes/bulk',
    'bulk-actions/update-portfolio',
])

/**
 * True when the endpoint's 200 response is itself the terminal result. Async
 * endpoints (`bulk-actions/update`) instead return a `progress` ack and finish
 * later via the poller + `bulk-actions/run-info`.
 */
export const isSynchronousBulkActionEndpoint = (endpoint: string): boolean =>
    SYNCHRONOUS_BULK_ACTION_ENDPOINTS.has(endpoint)

export const normalizeAmazonPortfolioOptions = <
    T extends { portfolio_id: string | number | bigint },
>(response: {
    data: { data: T[] }
}): { data: { data: Array<T & { id: string }> } } => {
    response.data.data = response.data.data.map((portfolio) => ({
        ...portfolio,
        id: String(portfolio.portfolio_id),
    }))
    return response as { data: { data: Array<T & { id: string }> } }
}

export const portfolioSubmissionValue = (value: unknown, allowUnassigned: boolean): unknown =>
    allowUnassigned && value === '' ? null : value
